import { Carousel, Tag } from "antd";
import { ImageCheck, LinkWrapper } from "Admin/Components";
import { ImageCheckType } from "Admin/Config/ImageType";
import styles from "./FacultyCard.module.scss";

const FacultyCard = ({ data }) => {
  let data_list = [data];
  if (data?.duplicated_with_cross_institutions?.length > 0) {
    data_list = [data, ...data.duplicated_with_cross_institutions];
  }
  const Card = ({ data }) => {
    return (
      <LinkWrapper
        link={`/explore/faculty/${data.explore_slug || data.id}`}
        component={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
            }}
          >
            <div className={styles["faculty-card"]}>
              <div className={styles["brief"]}>
                <div className={styles["avatar"]}>
                  <ImageCheck
                    url={data.photo}
                    classname={styles["photo"]}
                    alt={"avatar"}
                    type={ImageCheckType.FACULTY_AVATAR}
                  />
                </div>
                <div className={styles["name-title"]}>
                  <div className={styles["faculty-name"]}>
                    <p>{data.name}</p>
                  </div>
                  {data.department.map((item, index) => {
                    return (
                      <p key={index} className={styles["institution"]}>{item}</p>
                    );
                  })}

                  <div className={styles["title"]}>
                    <p>{data.position}</p>
                  </div>
                </div>
              </div>

              {data.citation_count ? (
                <div className={styles["cited-by"]}>
                  Cited by {data.citation_count}
                </div>
              ) : (
                <></>
              )}
              {/* <div className={styles["tag"]}>
                {data.keywords.length >= 2 &&
                  data.keywords.slice(0, 2).map((item, index) => {
                    return (
                      <Tag
                        key={index}
                        color="var(--light-blue)"
                        style={{ cursor: "pointer", color: "var(--grey-text)" }}
                      >
                        {item.value}
                      </Tag>
                    );
                  })}
                {data.keywords.length > 2 && (
                  <Tag
                    key={4}
                    color="var(--light-blue)"
                    style={{ cursor: "pointer", color: "var(--grey-text)" }}
                  >
                    +{data.keywords.length - 2}
                  </Tag>
                )}
              </div> */}
            </div>
          </div>
        }
      />
    );
  };
  return data_list.length > 1 ? (
    <div>
      <Carousel arrows infinite={false}>
        {data_list.map((item, index) => {
          return <Card data={item} key={index} />;
        })}
      </Carousel>
    </div>
  ) : (
    <Card data={data} />
  );
};

export default FacultyCard;
